<script setup>
import { SearchOutlined } from '@ant-design/icons-vue';

const props = defineProps({
    formItems: {
        type: Array,
        required: true
    },
    formData: {
        type: Object,
        required: true
    },
    /** 緊湊：無標題、查詢/重置與欄位同一列 */
    compact: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['search', 'reset', 'change']);

const handleInputChange = (value, key) => {
    emit('change', { key, value });
};

const handleReset = () => {
    props.formItems.forEach((item) => {
        emit('change', { key: item.key, value: '' });
    });
    emit('reset');
};
</script>

<template>
    <a-card
        :bordered="false"
        class="admin-panel admin-filter-panel mb-5"
        :class="{ 'admin-filter-panel--compact': compact }"
    >
        <div v-if="!compact" class="admin-filter-panel__head">
            <span class="admin-filter-panel__title">篩選條件</span>
        </div>
        <a-form layout="vertical" class="admin-filter-form">
            <div class="admin-filter-grid">
                <template v-for="item in formItems" :key="item.key">
                    <a-form-item :label="item.label" class="!mb-0">
                        <a-input
                            v-if="!item.type || item.type === 'input'"
                            :value="formData[item.key]"
                            :placeholder="item.placeholder || '請輸入'"
                            allowClear
                            size="middle"
                            class="w-full min-w-0"
                            :disabled="
                                typeof item.disabled === 'function'
                                    ? item.disabled(formData)
                                    : !!item.disabled
                            "
                            @update:value="
                                (val) => handleInputChange(val, item.key)
                            "
                        />
                        <a-select
                            v-else-if="item.type === 'select'"
                            :value="
                                formData[item.key] === ''
                                    ? undefined
                                    : formData[item.key]
                            "
                            :placeholder="item.placeholder || '請選擇'"
                            :allowClear="item.allowClear === true"
                            class="w-full min-w-0"
                            :style="{ minWidth: '160px' }"
                            size="middle"
                            :show-search="item.showSearch === true"
                            :filter-option="
                                item.filterOption === false ? false : undefined
                            "
                            :loading="item.loading === true"
                            :disabled="
                                typeof item.disabled === 'function'
                                    ? item.disabled(formData)
                                    : !!item.disabled
                            "
                            @update:value="
                                (val) => handleInputChange(val, item.key)
                            "
                            @search="
                                item.onSearch
                                    ? (val) => item.onSearch(val, item.key)
                                    : undefined
                            "
                        >
                            <a-select-option
                                v-for="option in typeof item.options ===
                                'function'
                                    ? item.options()
                                    : item.options"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.label }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>
                <div v-if="compact" class="admin-filter-actions">
                    <a-button size="middle" @click="handleReset">重置</a-button>
                    <a-button
                        size="middle"
                        type="primary"
                        @click="$emit('search')"
                    >
                        <template #icon><search-outlined /></template>
                        查詢
                    </a-button>
                </div>
            </div>
            <div v-if="!compact" class="admin-filter-actions">
                <a-button size="middle" @click="handleReset">重置</a-button>
                <a-button
                    size="middle"
                    type="primary"
                    @click="$emit('search')"
                >
                    <template #icon><search-outlined /></template>
                    查詢
                </a-button>
            </div>
        </a-form>
    </a-card>
</template>
